"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_CODE_STATE = void 0;
exports.EMPTY_CODE_STATE = `# Press "+ Add" on the left to add an app action
# To invoke the action use '.execute()' in your code
# Then press "Test" on the top-right

`;
//# sourceMappingURL=code.js.map